._animationKitsList_1ny4z_1 {
  display: flex;
  flex-direction: column;
  gap: 10px; }
  ._animationKitsList_1ny4z_1 ._animationKitButton_1ny4z_5 {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content; }
